import {
  Directive,
  ElementRef,
  EventEmitter,
  NgZone,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';

@Directive({
  selector: '[doubletap]',
  standalone: true
})
export class DoubleTapDirective implements OnInit, OnDestroy {
  @Output() doubletap = new EventEmitter<PointerEvent>();

  private lastTapTime = 0;
  private lastTapX = 0;
  private lastTapY = 0;
  private pointerDown = false;

  private onPointerDown = (ev: PointerEvent) => {
    // Only consider primary touch/pointer
    if (ev.isPrimary === false) return;
    this.pointerDown = true;
  };

  private onPointerUp = (ev: PointerEvent) => {
    if (!this.pointerDown || (ev.isPrimary === false)) return;
    const now = performance.now();
    const x = ev.clientX;
    const y = ev.clientY;

    const dt = now - this.lastTapTime;
    const dx = Math.abs(x - this.lastTapX);
    const dy = Math.abs(y - this.lastTapY);

    // 300ms window and small movement threshold for a double tap
    if (dt > 0 && dt <= 300 && dx < 24 && dy < 24) {
      // Run inside Angular zone for change detection
      this.zone.run(() => this.doubletap.emit(ev));
      this.lastTapTime = 0; // reset
    } else {
      this.lastTapTime = now;
      this.lastTapX = x;
      this.lastTapY = y;
    }
    this.pointerDown = false;
  };

  private onClick = (ev: MouseEvent) => {
    // Prevent synthetic double-clicks from firing in addition to pointer
    // Do nothing; pointer events handle the logic
  };

  constructor(private el: ElementRef, private zone: NgZone) {}

  ngOnInit(): void {
    const el = this.el.nativeElement as HTMLElement;
    // Ensure we opt-in to touch-action that allows vertical panning
    el.style.touchAction = el.style.touchAction || 'pan-y';

    el.addEventListener('pointerdown', this.onPointerDown, { passive: true });
    el.addEventListener('pointerup', this.onPointerUp, { passive: true });
    // Optional: listen to mouse events fallback (browsers without PointerEvents are rare now)
    el.addEventListener('click', this.onClick, { passive: true });
  }

  ngOnDestroy(): void {
    const el = this.el.nativeElement as HTMLElement;
    el.removeEventListener('pointerdown', this.onPointerDown as any);
    el.removeEventListener('pointerup', this.onPointerUp as any);
    el.removeEventListener('click', this.onClick as any);
  }
}
